import React from "react"

const SearchBox = ({ onChange, placeholder, onSubmit, className }) => (
  <div className={`relative mr-6 my-2 ${className}`} style={{ minWidth: 350 }}>
    <input
      type="text"
      className="bg-pink-white w-full shadow-md rounded-full border border-pink-500 p-3 focus:outline-none focus:ring focus:border-pink-500 focus:ring-pink-300"
      placeholder={placeholder}
      onChange={onChange}
    />
    <button
      type="button"
      onClick={onSubmit}
      className="absolute top-3 right-4 text-purple-lighter"
    >
      <img src="/images/search-icon.svg" alt="Buscar" />
    </button>
  </div>
)

export default SearchBox
